<template>
  <el-dialog
    v-model="showVideoChatDataValue"
    title="视频通话"
    :before-close="handleClose"
    :closeOnClickModal="false"
    width="800px"
  >
    <div class="video-container">
      <video class="remote-video" playsinline autoplay :srcObject="rmSrcObjValue"></video>
      <video class="local-video" playsinline autoplay muted :srcObject="srcObjValue"></video>

      <div class="control-panel">
        <div class="user-info">
<!--          <el-input-->
<!--            v-model="toUser"-->
<!--            placeholder="输入好友账号"-->
<!--            :style="{ visibility: showUserInput ? 'visible' : 'hidden' }"-->
<!--            class="user-input"-->
<!--          />-->
          <el-button type="success" class="call-btn">
            呼叫车场：{{ callingCheckPointValue.areaName }}
          </el-button>
          <el-button type="danger">
            通道：{{ callingCheckPointValue.name }}
          </el-button>
        </div>
        <div class="action-buttons">
<!--          <el-button type="success" @click="handleCallClick" class="call-btn">-->
<!--            <i class="el-icon-video-camera"></i> 视频通话-->
<!--          </el-button>-->
          <el-button
            type="danger"
            @click="handleHangupClick"
            class="hangup-btn"
          >
            <i class="el-icon-switch-button"></i> 挂断
          </el-button>
        </div>
      </div>
    </div>
  </el-dialog>
</template>
<!-- 可引可不引 -->
<!--<script th:src="@{/js/adapter-2021.js}"></script>-->
<script>
import { mapState } from 'vuex';
import store from "../../store/index";
export default {
  data() {
    return {
      toUser: "",
      authToken: "", // eslint校验避免使用下划线开头
      showUserInput: true,
      user: JSON.parse(localStorage.getItem("userInfo"))
    };
  },
  computed: {
    ...mapState([
      'showVideoChatData',
      'websocket',
      'srcObj',
      'rmSrcObj',
      'peer',
      'callingCheckPoint',
    ]),
    showVideoChatDataValue: {
      get() {
        return this.showVideoChatData; // 从 Vuex 获取值
      },
      set(value) {
        this.$store.commit('setShowVideoChatData', value); // 更新 Vuex 中的值
      }
    },
    websocketValue: {
      get() {
        return this.websocket; // 从 Vuex 获取值
      },
      set(value) {
        this.$store.commit('setWebsocket', value); // 更新 Vuex 中的值
      }
    },
    srcObjValue: {
      get() {
        return this.srcObj; // 从 Vuex 获取值
      },
      set(value) {
        this.$store.commit('setSrcObj', value); // 更新 Vuex 中的值
      }
    },
    rmSrcObjValue: {
      get() {
        return this.rmSrcObj; // 从 Vuex 获取值
      },
      set(value) {
        this.$store.commit('setRmSrcObj', value); // 更新 Vuex 中的值
      }
    },
    peerValue: {
      get() {
        return this.peer; // 从 Vuex 获取值
      },
      set(value) {
        this.$store.commit('setPeer', value); // 更新 Vuex 中的值
      }
    },
    callingCheckPointValue: {
      get() {
        return this.callingCheckPoint; // 从 Vuex 获取值
      },
      set(value) {
        this.$store.commit('setCallingCheckPoint', value); // 更新 Vuex 中的值
      }
    }
  },
  mounted() {
  },
  // beforeUnmount() {
  //   // 清理资源
  //   if (this.websocket) {
  //     this.websocket.close();
  //   }
  //   if (Company.peer) {
  //     Company.peer.close();
  //   }
  //   if (this.heartbeatInterval) {
  //     clearInterval(this.heartbeatInterval);
  //   }
  // },
  methods: {
    handleClose(done) {
      done();
    },
    showDialog() {
      store.commit("setShowVideoChatData", true);
    },


    //视频通话
    handleCallClick() {
      this.showUserInput = false;

      if (!this.toUser) {
        alert("请先指定好友账号，再发起视频通话！");
        return;
      }

      if (store.state.peer == null) {
        this.WebRTCInit();
      }

      let cfUserMessage = {
        id: "",
        fromUid: "",
        toUid: this.toUser,
        groupId: "",
        status: 0,
        contents: "",
        type: 0,
        client: "",
        ip: "",
        createTime: 0,
        receiveTime: 0,
      };

      let message = {
        type: "call_start",
        cfUserMessage: cfUserMessage,
        ext: "",
      };
      store.state.websocket.send(JSON.stringify(message));
    },

    //挂断
    handleHangupClick() {
      this.showUserInput = false;

      if (store.state.srcObj) {
        const videoTracks = store.state.srcObj.getVideoTracks();
        videoTracks.forEach((videoTrack) => {
          videoTrack.stop();
          store.state.srcObj.removeTrack(videoTrack);
        });
      }

      if (store.state.rmSrcObj) {
        const videoTracks = store.state.rmSrcObj.getVideoTracks();
        videoTracks.forEach((videoTrack) => {
          videoTrack.stop();
          store.state.rmSrcObj.removeTrack(videoTrack);
        });

        //挂断同时，通知对方
        let cfUserMessage = {
          id: "",
          fromUid: "",
          toUid: this.toUser,
          groupId: "",
          status: 0,
          contents: "",
          type: 0,
          client: "",
          ip: "",
          createTime: 0,
          receiveTime: 0,
        };

        let message = {
          type: "hangup",
          cfUserMessage: cfUserMessage,
          ext: "",
        };
        store.state.websocket.send(JSON.stringify(message));
      }

      if (store.state.peer) {
        store.state.peer.ontrack = null;
        store.state.peer.onremovetrack = null;
        store.state.peer.onremovestream = null;
        store.state.peer.onicecandidate = null;
        store.state.peer.oniceconnectionstatechange = null;
        store.state.peer.onsignalingstatechange = null;
        store.state.peer.onicegatheringstatechange = null;
        store.state.peer.onnegotiationneeded = null;

        store.state.peer.close();
        store.commit("setPeer", null);
      }
      store.commit("setSrcObj", null);
      store.commit("setRmSrcObj", null);
      store.commit("setCalling", false);

      store.commit("setShowVideoChatData", false);
    },
  },
};
</script>

<style scoped>
/* 使用 ::v-deep */
::v-deep .el-dialog {
  border-radius: 12px;
  background: #333;
}

.video-container {
  position: relative;
  width: 100%;
  height: 500px;
  background: #222;
  border-radius: 0 0 12px 12px;
  overflow: hidden;
}

.remote-video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  background: #000;
}

.local-video {
  position: absolute;
  top: 20px;
  right: 20px;
  width: 160px;
  height: 240px;
  border: 2px solid white;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  background: #757474;
  z-index: 10;
}

.control-panel {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.7);
  padding: 15px 20px;
  z-index: 10;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.user-info {
  display: flex;
  align-items: center;
  gap: 15px;
}

.user-id {
  color: white;
  font-size: 14px;
  font-weight: 500;
}

.user-input {
  flex: 1;
}

.user-input >>> .el-input__inner {
  background: rgba(255, 255, 255, 0.9);
  border: none;
  border-radius: 20px;
  padding-left: 15px;
  height: 36px;
  line-height: 36px;
}

.action-buttons {
  display: flex;
  justify-content: center;
  gap: 20px;
}

.call-btn {
  background: linear-gradient(135deg, #00b09b 0%, #96c93d 100%);
  border: none;
  color: white;
  border-radius: 20px;
  padding: 8px 25px;
  font-weight: 500;
  transition: all 0.3s;
}

.call-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 176, 155, 0.3);
}

.hangup-btn {
  background: linear-gradient(135deg, #ff416c 0%, #ff4b2b 100%);
  border: none;
  color: white;
  border-radius: 20px;
  padding: 8px 25px;
  font-weight: 500;
  transition: all 0.3s;
}
</style>
